<template>
  <div
    class="py-1 px-2 rounded-md max-w-40 truncate cursor-pointer"
    :style="dynStyle"
    :class="`bg-${bgColor} text-${textColor} text-${size}`"
    :id="`tag_${label}_${id}`"
    :title="label"
  >
    <slot>
      {{ label }}
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: 0,
    },
    textColor: {
      type: String,
      default: 'white',
    },
    bgColor: {
      type: String,
      default: 'gray-500',
    },
    size: {
      type: String,
      default: 'xs',
    },
  },
  computed: {
    dynStyle () {
      if (typeof this.bgColor === 'string' && this.bgColor.includes('#')) {
        return `max-width: 10rem; background-color: ${this.bgColor}; color: white;`
      } else {
        return 'max-width: 13rem;'
      }
    },
  },
}
</script>
